
setInterval(function()
{
        var ks = $('input[name ="properties[product_sku]"]').val();
           if (ks.match (/not available/)){
             document.getElementById("NOTE").innerHTML = '<div style="padding:5px;color:white;background-color:#1C7DD5;border:2px solid rgb(207, 207, 207);"><p style="text-align:center;margin-bottom:2px;"><b>Protection jacket combination not possible. Please change!</b></p></div>';
             //  $("#DfpP").hide();
              
           }
       else{
           document.getElementById("NOTE").innerHTML = '';
       }
      
           

     
  }, 300);   
   
